import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelBenchmarkInsightCardOverlay from 'lumen/components/hotel/benchmark-insight/card-overlay';

interface HotelBenchmarkInsightSectionsSectionSegmentSectionSegmentOverlaySignature {
  Args: {};
}

export default class HotelBenchmarkInsightSectionsSectionSegmentSectionSegmentOverlay extends Component<HotelBenchmarkInsightSectionsSectionSegmentSectionSegmentOverlaySignature> {
  @service declare access: Services['access'];

  @service('benchmark-insight/features')
  declare benchmarkInsightFeatures: Services['benchmark-insight/features'];
  @service declare intercom: Services['intercom'];
  @service declare router: Services['router'];
  @service declare usageAnalytics: Services['usage-analytics'];

  @action
  onClickGoToMapping(): void {
    this.router.transitionTo('hotel.settings.mapping.benchmark');

    this.usageAnalytics.track('Mapping Learned More', {
      eventTrigger: 'section-segment-overlay',
      product: 'benchmark-insight',
    });
  }

  @action
  onClickLearnMore(): void {
    this.intercom.redirectToIntercomHelp(
      'en/articles/8272072-get-started-with-benchmark-insight',
    );

    this.usageAnalytics.track('Segmentation Learned More', {
      eventTrigger: 'section-segment-overlay',
      product: 'benchmark-insight',
    });
  }

  <template>
    <HotelBenchmarkInsightCardOverlay>
      {{#if this.benchmarkInsightFeatures.showGoToMappingMessage}}
        <PrismMessage
          @description={{t
            "benchmark_insight.trial_without_data.segmentation_overlay.body.2"
          }}
          @title={{t
            "benchmark_insight.trial_without_data.segmentation_overlay.title"
          }}
          data-test-id="section-segment-overlay-pms-mapping"
        >
          <:primaryAction>
            {{#if this.access.hasBenchmarkInsightMappingEditRights}}
              <PrismButton
                @buttonType="primary"
                @iconAfter="arrow-right"
                @label={{t
                  "benchmark_insight.trial_without_data.segmentation_overlay.cta"
                }}
                {{on "click" this.onClickGoToMapping}}
              />
            {{/if}}
          </:primaryAction>
        </PrismMessage>
      {{else}}
        <PrismMessage
          @description={{t
            "benchmark_insight.trial_without_data.segmentation_overlay.body.1"
          }}
          @title={{t
            "benchmark_insight.trial_without_data.segmentation_overlay.title"
          }}
          data-test-id="section-segment-overlay-learn-more"
        >
          <:primaryAction>
            <PrismButton
              @buttonType="primary"
              @iconBefore="book"
              @label={{t "benchmark_insight.segmentation.overlay.learn_more"}}
              {{on "click" this.onClickLearnMore}}
            />
          </:primaryAction>
        </PrismMessage>
      {{/if}}
    </HotelBenchmarkInsightCardOverlay>
  </template>
}
